import React from 'react';
import './style.scss';
import Icon from '../Controls/Icon/Icon';
import { ICONS } from '../../../constants/icons';
import { appStore } from '../../../mobx/appStore';
import { localeStore } from '../../../mobx/localesStore';
import { formatPrice, getTranslate } from 'src/utils/formatter';
import { branchStore } from 'src/mobx/barnchStore';
import { TTranslate } from 'src/types/main';
import Skeleton from 'react-loading-skeleton';
import { CASHBACK_ERROR_CODE } from 'src/constants/orders';

interface IProps {
  name: TTranslate | undefined;
  description: TTranslate | undefined;
  amount: number;
  loading?: boolean;
  isCheckout?: boolean;
  className?: string;
  error?: { message: string | null; code: number | null };
}

export const Cashback: React.FC<IProps> = ({
  name,
  description,
  loading = false,
  amount,
  className,
  isCheckout,
  error,
}) => {
  if (!branchStore.branch?.is_cashback || !appStore.settings?.is_cashback) return null;

  const currency =
    localeStore.language === 'ar' ? appStore.settings?.wallet_currency_ar : appStore.settings?.wallet_currency;

  const adaptiveStyles = {
    marginBottom: isCheckout ? 25 : 10,
    marginTop: isCheckout ? 0 : 10,
  };

  if (loading) {
    return <Skeleton className="product-submit-item" style={{ borderRadius: 12, height: 50 }} />;
  }

  if (error?.message && error?.code !== CASHBACK_ERROR_CODE.CHANGED_CONDITIONS) {
    return (
      <div className="cashback__error family-regular text-size-12 color-red" style={adaptiveStyles}>
        {error.message}
      </div>
    );
  }

  return (
    <div className={`cashback ${className ?? ''}`} style={adaptiveStyles}>
      <Icon name={ICONS.CASHBACK} size={18} color={'#88B78C'} />
      <div className="cashback-container">
        <div className="cashback-info">
          <div className="cashback-offer-name">{getTranslate(name)}</div>
          <div className="cashback-value">{formatPrice(+amount, currency)}</div>
        </div>
        <div className="cashback-description">{getTranslate(description)}</div>
      </div>
    </div>
  );
};
